import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import CustomPaginationActionsTable from "../../../components/design-system/table";


const RewardPage: React.FC = () => {
  return (
    <Box height="100vh" bgcolor="#FFFFFF">
        <Typography variant='h4' color='textPrimary'>Prêmios</Typography>
        <Typography variant="subtitle1" color="textSecondary">Aqui você pode acompanhar os prêmios disponiveis para resgate</Typography>

        <CustomPaginationActionsTable  />        
    </Box>
  );
}

export default RewardPage;